import { FunctionComponent, memo } from "react";
import { IProps } from "./maximum-chart-data.types";
import { MAXIMUM_DATA_POINTS } from "./maximum-chart-data.constants";
import "./maximum-chart-data.scss";

/**
 * Display a message if the chart data exceeds the maximum length. Otherwise, show the chart.
 * @param props.children               The chart to display.
 * @param props.dataLength             The length of the chart data.
 * @param props.maximumChartDataLength The maximum length of the chart data before the message is displayed.
 * @returns
 */
const MaximumChartData: FunctionComponent<IProps> = ({
    children,
    dataLength,
    maximumChartDataLength = MAXIMUM_DATA_POINTS,
}) => {
    if (dataLength > maximumChartDataLength) {
        return <div>Too much data to display</div>;
    }
    return <>{children}</>;
};

export default memo(MaximumChartData);
